export const getStatusHeading = (
  isProcessing?: boolean,
  isError?: boolean,
  percentageComplete?: number
) => {
  if (isProcessing) {
    if (isError) {
      return 'Processing failed';
    }
    return 'Processing...';
  }
  if (isError) {
    return 'Upload failed';
  }
  if (percentageComplete === 100) {
    return 'Uploaded!';
  }
  return 'Uploading...';
};

export const getStatusLabel = (
  isProcessing?: boolean,
  isError?: boolean,
  percentageComplete?: number
) => {
  if (isProcessing) {
    if (isError) {
      return 'Hit “cancel” to start over.';
    }
    return 'An audio preview will be ready soon';
  }
  if (isError) {
    return 'Hit “retry” to try again.';
  }
  return `${percentageComplete}%`;
};
